import { render, staticRenderFns } from "./addList.vue?vue&type=template&id=6ab5abcb"
import script from "./addList.vue?vue&type=script&lang=js"
export * from "./addList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports